import { lazy } from 'react';

export const SbSharedInteriorsPhotoModalRendererLazy = lazy(
    () =>
        import(
            /* webpackChunkName: "SbSharedInteriorsPhotoModalRenderer" */ './SbSharedInteriorsPhotoModalRenderer'
        )
);
